/* TeamTypeLabel.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozg1b66%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c116y%7Bdisplay%3Ainline-flex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._s7n41q9y%7Bvertical-align%3Abaseline%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._o5721q9c%7Bwhite-space%3Anowrap%7D");
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';
import { VerifiedTeamIcon } from '@atlassian/people-teams-ui/verified-team-icon';
import { useIntl } from 'react-intl';
const styles = {
  verifiedIconWrapper: "_bozg1b66 _1e0c116y _4cvr1h6o _s7n41q9y _o5721q9c"
};
export type TeamTypeLabelProps = {
  name: string;
  verified?: boolean | null;
  wrapText?: boolean;
};
export const TeamTypeLabel = ({
  name,
  verified,
  wrapText = false
}: TeamTypeLabelProps): React.JSX.Element => {
  const intl = useIntl();
  const verifiedIcon = verified ? <Box as="span" xcss={styles.verifiedIconWrapper}>
			<VerifiedTeamIcon showTooltip customTooltipContent={intl.formatMessage({
      id: 'townsquare.teams-settings.team-type-label.verifiedTeamIconTooltip',
      defaultMessage: 'Verified Team',
      description: 'Tooltip for the Verified Team icon shown next to a team type name.'
    })} size="small" spacing="none" />
		</Box> : null;
  return <Inline space="space.025" alignBlock="center">
			<Text maxLines={wrapText ? 16 : 1}>{name}</Text>
			{verifiedIcon}
		</Inline>;
};